/**
 * Browser download helpers for file responses fetched with `responseType: 'blob'`.
 */

/** Save a Blob to disk under `filename`. */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

/** Filename from the response's Content-Disposition header, else `fallback`. */
export function filenameFromResponse(response, fallback) {
  const header = (response && response.headers && response.headers['content-disposition']) || ''
  const match = /filename="?([^";]+)"?/i.exec(header)
  return match ? match[1] : fallback
}

/**
 * Error message from a failed blob request. With `responseType: 'blob'` the
 * API's JSON error body arrives as a Blob, so read it back as text.
 */
export async function blobErrorMessage(error, fallback) {
  const data = error && error.response && error.response.data
  if (data instanceof Blob) {
    try {
      const body = JSON.parse(await data.text())
      if (body && body.message) return Array.isArray(body.message) ? body.message.join(', ') : body.message
    } catch (e) {
      // not JSON — fall through
    }
  }
  return fallback
}
